import React from 'react';
import {
  Create,
  Edit,
  EditButton,
  Filter,
  ReferenceField,
  ReferenceInput,
  required,
  TextField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../components';
import PriceInput from './PriceInput';
import PriceField from './coupons/PriceField';
import PriceSheetInput from './client_locations/PriceSheetInput';
import BulkDeleteButton from '../components/BulkDeleteButton';
import ReferenceChild from '../components/ReferenceChild';
import { getZ3PConfigValue, perPage } from '../helper';
import ListWithCSVImport from '../components/ListWithCSVImport';

const PriceFilter = (props) => (
  <Filter {...props}>
    <PriceSheetInput isRequired={false} alwaysOn {...props} />
    <ReferenceInput
      source="service_offering_id"
      reference="service-offering"
      sort={{ field: 'short_name', order: 'ASC' }}
      perPage={perPage}
      alwaysOn
    >
      <ReferenceChild
        {...props}
        optionText="short_name"
        source="service_offering_id"
      />
    </ReferenceInput>
  </Filter>
);

const listStyles = {
  nb_commands: { color: 'purple' },
};

const isUsingHelpText = getZ3PConfigValue('is_using_help_text');

export const PriceList = withStyles(listStyles)(({ classes, ...props }) => (
  <div>
    <ListWithCSVImport
      {...props}
      filters={<PriceFilter />}
      bulkActionButtons={<BulkDeleteButton />}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <TextField source="price_sheet_name" sortable={false} />
        <ReferenceField
          source="service_offering_id"
          reference="service-offering"
          sortable={false}
        >
          <TextField source="short_name" />
        </ReferenceField>
        <PriceField source="parts_cost_dollars" sortable={false} />
        <PriceField source="labor_cost_dollars" sortable={false} />

        <PriceField source="extra_oil_cost_per_qt_dollars" sortable={false} />
        <EditButton />
      </ZippityDatagrid>
    </ListWithCSVImport>

    {isUsingHelpText ? (
      <div>
        The <strong>Price Sheets</strong> are how we control prices for each
        client location.
        <ul>
          <li>
            Each Client Location has an assigned Price Sheet (e.g., NE Regular).
          </li>
          <li>
            Each bookable service should have a Price Sheet entry for every
            avaiable Price Sheet.
          </li>
          <li>
            If you need to duplicate a Price Sheet (e.g., to expand to a new
            geography), tell Max/Matt and we&apos;ll help.
          </li>
          <li>
            The customer doesn&apos;t see the individual Parts/Labor charge.
            They just see the total cost. But the individual Parts/Labor charge
            are used when calculating sales tax.
          </li>
        </ul>
      </div>
    ) : (
      <div>
        The <strong>Price Sheets</strong> are how we control prices.
      </div>
    )}
  </div>
));

const editStyles = {};

export const PriceEdit = withStyles(editStyles)(({ classes, ...props }) => (
  <Edit undoable={false} {...props}>
    <ZippitySimpleForm>
      <TextField source="price_sheet_id" />
      <TextField source="price_sheet_name" />
      <ReferenceInput
        source="service_offering_id"
        reference="service-offering"
        sort={{ field: 'short_name', order: 'ASC' }}
        perPage={perPage}
        validate={[required()]}
      >
        <ReferenceChild
          {...props}
          optionText="short_name"
          source="service_offering_id"
        />
      </ReferenceInput>
      <PriceInput source="parts_cost_dollars" isRequired />
      <PriceInput source="labor_cost_dollars" isRequired />
      <PriceInput source="extra_oil_cost_per_qt_dollars" />
    </ZippitySimpleForm>
  </Edit>
));

export const PriceCreate = withStyles(editStyles)(({ classes, ...props }) => (
  <Create {...props}>
    <ZippitySimpleForm>
      <PriceSheetInput isRequired {...props} />
      <ReferenceInput
        source="service_offering_id"
        reference="service-offering"
        sort={{ field: 'short_name', order: 'ASC' }}
        perPage={perPage}
        validate={[required()]}
      >
        <ReferenceChild
          {...props}
          optionText="short_name"
          source="service_offering_id"
        />
      </ReferenceInput>
      <PriceInput source="parts_cost_dollars" isRequired />
      <PriceInput source="labor_cost_dollars" isRequired />
      <PriceInput source="extra_oil_cost_per_qt_dollars" />
    </ZippitySimpleForm>
  </Create>
));
